import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-code-input',
  templateUrl: './code-input.component.html',
  styleUrls: ['./code-input.component.scss']
})
export class CodeInputComponent implements OnInit {
  @Input() codeLength = 4;
  @Input() autofocus = true;
  @Output() codeChange: EventEmitter<string> = new EventEmitter<string>();
  space = 0;
  @ViewChild('codeInput') codeInput: ElementRef<HTMLInputElement>;
  @ViewChild('fakeContainer') fakeContainer: ElementRef<HTMLDivElement>;

  private _code = '';

  get code(): string {
    return this._code;
  }

  @Input() set code(value: string) {
    if (this._code !== value) {
      this._code = value;
      this.codeChange.emit(this._code);
    }
  }

  ngOnInit(): void {
    this.updateSpace();
    if (this.autofocus) {
      this.codeInput.nativeElement.focus();
    }
  }

  updateSpace() {
    const styles = window.getComputedStyle(this.codeInput.nativeElement);
    const padding = parseFloat(styles.paddingLeft) * 2 + parseFloat(styles.fontSize) * (this.codeLength - 2);
    this.space = this._code.length > 0 ?
      (this.fakeContainer.nativeElement.clientWidth - padding) / (this.codeLength - 1)
      : 0;
  }

  @HostListener('window:resize')
  onResize() {
    this.updateSpace();
  }
}
